export var EM_DASH = '—';
//# sourceMappingURL=char.js.map